import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';

const drawerWidth = {
  opened: {
    default: '23.5%',
    between1024And1200: '17%',
    lg: '14.5%',
    xl: '11%',
  },
  closed: {
    default: '0px',
    sm: '0px',
    between769And900: '0px',
    md: '0px',
    lg: '0px',
  },
};

const openedMixin = (theme) => ({
  width: drawerWidth.opened.default,
  [theme.breakpoints.down('lg')]: {
    width: drawerWidth.opened.default,
  },
  [theme.breakpoints.between(1024, 1200)]: {
    width: drawerWidth.opened.between1024And1200,
  },
  [theme.breakpoints.up('lg')]: {
    width: drawerWidth.opened.lg,
  },
  [theme.breakpoints.up('xl')]: {
    width: drawerWidth.opened.xl,
  },
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'unset',
});

const closedMixin = (theme) => ({
  width: drawerWidth.closed.default,
  [theme.breakpoints.up('sm')]: {
    width: drawerWidth.closed.sm,
  },
  [theme.breakpoints.between(769, 900)]: {
    width: drawerWidth.closed.between769And900,
  },
  [theme.breakpoints.up('md')]: {
    width: drawerWidth.closed.md,
  },
  [theme.breakpoints.up('lg')]: {
    width: drawerWidth.closed.lg,
  },
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'unset',
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export default Drawer;
